<template>
  <div class="box3">
    <img class="title" src="../../../assets/coursePage/acp/box3/title.png" />
    <div class="content">
      <ul>
        <li>
          <a></a>
          <p class="title">其他机构ACP课程</p>
        </li>
        <li>
          <a>案例<br />实操</a>
          <p>
            <span><i class="grey"></i><em>纯官网项目练习</em></span>
            <span><i class="grey"></i><em>考前无实操锻炼</em></span>
          </p>
        </li>
        <li>
          <a>资源<br />领用</a>
          <p>
            <span><i class="grey"></i><em>学生自行去官方网站领用</em></span>
            <span><i class="grey"></i><em>零散且混乱</em></span>
          </p>
        </li>
        <li>
          <a>技术<br />应用</a>
          <p>
            <span><i class="grey"></i><em>照搬官方视频课程</em></span>
            <span><i class="grey"></i><em>只讲理论不实战</em></span>
            <span><i class="grey"></i><em>为考证而考证</em></span>
          </p>
        </li>
        <div class="current">
          <p class="title">博学谷ACP课程</p>
          <p>
            <span><i class="white"></i><em>融入企业级案例</em></span>
            <span><i class="white"></i><em>真实还原业务场景</em></span>
            <span><i class="white"></i><em>考证+实际工作都用得到</em></span>
          </p>
          <p>
            <span
              ><i class="white"></i
              ><em>课程涉及云资源倾囊相赠，统一打包</em></span
            >
            <span><i class="white"></i><em>方便一次性领取</em></span>
          </p>
          <p>
            <span><i class="white"></i><em>基于阿里云技术标准</em></span>
            <span><i class="white"></i><em>引进全新技术栈</em></span>
            <span><i class="white"></i><em>攻克多层技术壁垒</em></span>
          </p>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
}
.content {
  background: url("../../../assets/coursePage/acp/box3/bg.png") no-repeat;
  background-size: 100% 100%;
  background-position: top center;
  height: 570px;
  padding: 93px 30px 109px;
  position: relative;
  top: -64px;
  margin-bottom: -64px;
  ul {
    width: 100%;

    margin: 0 auto;
    background-image: linear-gradient(
      -45deg,
      #ffd9b2 0%,
      #fff2e5 43%,
      #ffe5cc 100%
    );
    box-shadow: 0px 6px 30px 0px #ffe5cc;
    border-radius: 20px;
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    li {
      display: flex;
      justify-content: space-between;
      height: 155px;
      align-items: center;
      border-bottom: 1px solid #ffd9b2;
      a {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #332114;
      }
      p {
        font-family: PingFang-SC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #808080;
        width: 226px;
        text-align: left;
        span {
          display: flex;
          i {
            width: 6px;
            height: 6px;
            background-color: #999999;
            display: inline-block;
            margin-right: 4px;
            display: block;
            border-radius: 3px;
            margin-top: 14px;
          }
          em {
            font-style: normal;
            flex: 1;
          }
        }
      }
      p.title {
        font-family: PingFang-SC-Bold;
        font-size: 26px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 1px;
        color: #808080;
      }
    }
    li:nth-child(1) {
      height: 89px;
    }
    li:nth-child(4) {
      border-bottom: none;
    }
    .current {
      position: absolute;
      left: 14%;
      top: -29px;
      width: 320px;
      height: 616px;
      background-color: #ff7f00;
      box-shadow: 0px 6px 50px 0px #ffbf7f;
      border-radius: 30px;
      p {
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #ffffff;
        height: 156px;

        border-bottom: 1px solid #ffd9b2;
        padding: 24px 28px 0;
        box-sizing: border-box;
        span {
          display: flex;
          align-items: flex-start;
          i {
            width: 6px;
            height: 6px;
            background-color: #fff;
            display: inline-block;
            margin-right: 4px;
            border-radius: 3px;
            font-style: normal;
            margin-top: 14px;
            display: block;
          }
          em {
            font-style: normal;
            flex: 1;
          }
        }
      }
      p.title {
        font-family: PingFang-SC-Heavy;
        font-size: 32px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 120px;
        letter-spacing: 2px;
        color: #ffffff;
        height: 120px;
        padding-top: 0;
      }
      p:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>